
import { AlertDialog, AlertDialogContent, AlertDialogHeader, AlertDialogTitle, 
  AlertDialogDescription, AlertDialogFooter, AlertDialogCancel, AlertDialogAction } from "@/components/ui/alert-dialog";
import { Diagram } from "@/utils/diagramService";
import { useEffect, useState } from "react";

interface DeleteDiagramDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  diagram: Diagram | null;
  onConfirm: () => void;
}

export function DeleteDiagramDialog({ 
  open, 
  onOpenChange, 
  diagram, 
  onConfirm 
}: DeleteDiagramDialogProps) {
  const [isDeleting, setIsDeleting] = useState(false);
  const [internalOpen, setInternalOpen] = useState(false);
  
  useEffect(() => {
    setInternalOpen(open);
  }, [open]);

  const handleConfirm = async () => {
    setIsDeleting(true);
    try {
      await onConfirm();
    } finally {
      setIsDeleting(false);
      handleOpenChange(false);
    }
  };

  const handleOpenChange = (newOpen: boolean) => {
    if (isDeleting) return;
    
    setInternalOpen(newOpen);
    if (!newOpen) {
      // Allow animation to complete before notifying parent
      setTimeout(() => {
        onOpenChange(false);
      }, 100);
    } else {
      onOpenChange(true);
    }
  };

  return (
    <AlertDialog open={internalOpen} onOpenChange={handleOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Confirmar exclusão</AlertDialogTitle>
          <AlertDialogDescription>
            Tem certeza que deseja excluir o diagrama "{diagram?.name}"?
            Esta ação não pode ser desfeita.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel disabled={isDeleting}>Cancelar</AlertDialogCancel>
          <AlertDialogAction 
            onClick={handleConfirm}
            disabled={isDeleting}
            className="bg-destructive text-destructive-foreground hover:bg-destructive/90"
          >
            {isDeleting ? "Excluindo..." : "Excluir"}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
